import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
    checked = false;
    indeterminate = false;
    labelPosition = 'after';
    disabled = false;

    constructor() {}

    ngOnInit() {}
}
